import Utils from '../../Utils.js';;

export async function handleLinkPaste(link, position) {
  if (Utils.youtubeId(link)) {
    await Utils.addYoutube({ text: link, position });
  } else {
    await Utils.addCrawlerData({ link, position, timeout: 5000 });
  }
}